// src/lib/questions.js
// ─────────────────────────────────────────────────────────────
// Centrální definice všech otázek formuláře
// ─────────────────────────────────────────────────────────────

export const QUESTIONS = [
  // ── Sekce 1: Osobní informace ──────────────────────────────
  {
    key:      'name',
    label:    'Jméno a příjmení',
    qNum:     'Q1',
    type:     'text',
    required: true,
    maxLen:   100,
    placeholder: 'Jan Novák',
    section:  1,
  },
  {
    key:      'email',
    label:    'E-mail',
    qNum:     'Q2',
    type:     'email',
    required: true,
    maxLen:   200,
    placeholder: 'jan@example.com',
    section:  1,
  },
  {
    key:      'phone',
    label:    'Telefon',
    qNum:     'Q3',
    type:     'tel',
    required: true,
    maxLen:   30,
    placeholder: '+420 777 123 456',
    section:  1,
  },
  {
    key:      'edu',
    label:    'Absolvované studium',
    qNum:     'Q4',
    type:     'textarea',
    required: true,
    maxLen:   500,
    rows:     3,
    hint:     'Uveď obor, fakultu, školu a datum ukončení.',
    placeholder: 'Např.: Informatika, FIT ČVUT Praha, červen 2022',
    section:  1,
  },
  {
    key:      'jobs',
    label:    'Pracovní závazky',
    qNum:     'Q5',
    type:     'textarea',
    required: false,
    maxLen:   400,
    rows:     2,
    hint:     'Forma (zaměstnanec / OSVČ / s.r.o. / jiné), kde a kolik hodin měsíčně. Pokud nemáš žádné, napiš „Nemám."',
    placeholder: 'Např.: OSVČ, freelance UX, ~40 h/měsíc',
    section:  1,
  },

  // ── Sekce 2: Motivace ──────────────────────────────────────
  {
    key:      'motiv',
    label:    'Proč chceš založit startup?',
    qNum:     'Q6',
    type:     'textarea',
    required: true,
    maxLen:   2000,
    rows:     6,
    hint:     'Jaká je tvoje dlouhodobá vize? Proč máš získat Founder stipendium?',
    placeholder: 'Popiš svou motivaci a vizi…',
    section:  2,
  },

  // ── Sekce 3: Startup nápad ─────────────────────────────────
  {
    key:      'idea',
    label:    'Popis nápadu v 1–2 větách',
    qNum:     'Q7',
    type:     'textarea',
    required: true,
    maxLen:   400,
    rows:     2,
    placeholder: 'Stručně a výstižně…',
    section:  3,
  },
  {
    key:      'area',
    label:    'Oblast uplatnění',
    qNum:     'Q8',
    type:     'textarea',
    required: true,
    maxLen:   1500,
    rows:     4,
    hint:     'Potřeba, kterou řeší produkt, a cílové skupiny zákazníků a uživatelů.',
    section:  3,
  },
  {
    key:      'uniq',
    label:    'Inovativnost produktu',
    qNum:     'Q9',
    type:     'textarea',
    required: true,
    maxLen:   2000,
    rows:     5,
    hint:     'Jak jinak řeší potřebu trhu oproti konkurenci? Uveď konkrétní konkurenty, včetně těch nabízejících jiné řešení stejného problému.',
    section:  3,
  },
  {
    key:      'demand',
    label:    'Zájem o produkt',
    qNum:     'Q10',
    type:     'textarea',
    required: true,
    maxLen:   2000,
    rows:     5,
    hint:     'Jak vypadá současný trh – velikost, potenciál růstu? Proč zákazníci zaplatí? (Např. „Udělal/a jsem primární průzkum trhu…")',
    section:  3,
  },
  {
    key:      'phase',
    label:    'Aktuální fáze nápadu',
    qNum:     'Q11',
    type:     'textarea',
    required: true,
    maxLen:   1500,
    rows:     4,
    hint:     'Co už jsi odpracoval/a; co „máš v ruce"; pokud máš prototyp, jaké má prozatímní funkcionality.',
    section:  3,
  },
  {
    key:      'goals',
    label:    'Cíle na 3 měsíce',
    qNum:     'Q12',
    type:     'textarea',
    required: true,
    maxLen:   1500,
    rows:     5,
    hint:     'Popiš 3–5 hlavních cílů (byznysové i technické). Tyto milníky budeš reflektovat na konci 1. fáze programu.',
    section:  3,
  },
  {
    key:      'risks',
    label:    'Rizika projektu',
    qNum:     'Q13',
    type:     'textarea',
    required: true,
    maxLen:   1500,
    rows:     4,
    hint:     'Popiš technická i byznysová rizika a jejich případná řešení.',
    section:  3,
  },

  // ── Sekce 4: Tým ──────────────────────────────────────────
  {
    key:      'team',
    label:    'Tým projektu',
    qNum:     'Q14',
    type:     'textarea',
    required: true,
    maxLen:   2000,
    rows:     5,
    hint:     'Jména, kompetence, role (interní i externí). Silné/slabé stránky. Chybějící kompetence a plán jejich řešení.',
    section:  4,
  },
  {
    key:      'equip',
    label:    'Přístrojové vybavení',
    qNum:     'Q15',
    type:     'textarea',
    required: false,
    maxLen:   800,
    rows:     3,
    hint:     'Potřebuješ specializovaný software, hardware nebo laboratoř? Jaký?',
    section:  4,
  },

  // ── Sekce 5: Přílohy ──────────────────────────────────────
  {
    key:      'video',
    label:    'Odkaz na video',
    qNum:     'Q16',
    type:     'url',
    required: true,
    maxLen:   500,
    placeholder: 'https://youtu.be/...',
    hint:     'Představ sebe a nápad v max. 120 s. Selfie kamera stačí. YouTube / Vimeo / Google Drive…',
    section:  5,
  },
  {
    key:      'file17',
    label:    'Doklad o ukončení vzdělání',
    qNum:     'Q17',
    type:     'file',
    required: true,
    hint:     'Maturitní vysvědčení nebo diplom s datem ukončení. Max. 10 MB.',
    section:  5,
  },
  {
    key:      'file18',
    label:    'Další dokument',
    qNum:     'Q18',
    type:     'file',
    required: false,
    hint:     'Životopis nebo ukázky předchozích prací. Porotci mohou věnovat přílohám max. 15 minut. Max. 10 MB.',
    section:  5,
  },
];

export const SECTIONS = [
  { num: 1, label: 'Osobní informace' },
  { num: 2, label: 'Motivace & vize' },
  { num: 3, label: 'Startup nápad' },
  { num: 4, label: 'Tým & zdroje' },
  { num: 5, label: 'Přílohy & video' },
];

export const REQUIRED_KEYS = QUESTIONS
  .filter(q => q.required)
  .map(q => q.key);

export const MAX_FILE_SIZE_MB = 10;
export const ACCEPTED_FILE_TYPES = '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.jpeg,.png,.gif,.webp,.mp4,.mov,.avi,.mp3,.wav';
